// extracted by mini-css-extract-plugin
export default {"link":"ArrowCircleLink_link__kVq2B","icon":"ArrowCircleLink_icon__ShL9t","left":"ArrowCircleLink_left__bAxFl","right":"ArrowCircleLink_right__tyQxW"};